export const BREAKPOINT_DESKTOP = 1366;
export const BREAKPOINT_MAX = 1920;
export const BREAKPOINT_MIN = 375;
export const BREAKPOINT_MOBILE = 1024;
export const BREAKPOINT_PHONE = 700;
export const BREAKPOINT_RETINA = 2440;

export const HEADER_HEIGHT = 68;
export const SIDE_NAV_OFFSET = 118;
